import { skipToken } from "@tanstack/react-query";

import { api } from "~/utils/api";

export const useTeamById = (id: string | null | undefined) => {
  return api.person.getTeamById.useQuery(id ? { id } : skipToken);
};
